const storeList = () => {
  const stores = [
    {
      title: "Pro malé dobrodruhy",
      address:
        "Pro malé dobrodruhy, Kostelecká 938/81, 19600 Praha 9 - Čakovice",
      phone: "<a href='tel:+420 601 081 777'>+420 601 081 777</a>",
      email:
        "<a href='mailto:obchod@promaledobrodruhy.cz'>obchod@promaledobrodruhy.cz</a>",
      latitude: 50.15108635410194,
      longitude: 14.510412497574173,
      website: "https://www.promaledobrodruhy.cz",
      detailHref: "/branches/detail/?id=7517",
      openingHours: `Po - Pá: 11:00 - 19:30 <br>

Sobota: 10:00 - 18:30 <br>
Neděle: 10:00 - 18:30 <br>`,
      region: "Praha",
    },
    {
      title: "D-Style",
      address: "D-Style, Husova 16, 51401 Jilemnice",
      phone: "<a href='tel:+420 737 560 429'>+420 737 560 429</a>",
      email:
        "<a href='mailto:danamala1111@seznam.cz'>danamala1111@seznam.cz</a>",
      latitude: 50.60946545269303,
      longitude: 15.507375476038334,
      website: "https://www.facebook.com/dstylejilemnice/",
      detailHref: "/branches/detail/?id=7499",
      openingHours: `Po - Pá: 9:00 - 17:00 <br>

Sobota: 9:00 - 11:00 <br>
Neděle: ZAVŘENO <br>`,
      region: "Liberec",
    },
    {
      title: "Tvůj PROSTOR",
      address: "Tvůj PROSTOR, Gočárova třída 1265, 50002 Hradec Králové",
      phone: "<a href='tel:+420 773606459'>+420 773 606 459</a>",
      email:
        "<a href='mailto:niki@tvujprostorvhradci.cz'>niki@tvujprostorvhradci.cz</a>",
      latitude: 50.211986586491555,
      longitude: 15.815077228836252,
      website: "https://tvujprostorvhradci.cz/",
      detailHref: "/branches/detail/?id=7508",
      openingHours: `Po - Pá: 10:00 - 17:30 <br>

Sobota: ZAVŘENO <br>
Neděle: ZAVŘENO <br>`,
      region: "Hradec Králové",
    },
    {
      title: "Sportovní a dětská móda Jilemnice",
      address: "Sportovní a dětská móda Jilemnice, Husova 16, 51401 Jilemnice",
      phone: "<a href='tel:+420 737 560 429'>+420 737 560 429</a>",
      email:
        "<a href='mailto:danamala1111@seznam.cz'>danamala1111@seznam.cz</a>",
      latitude: 50.60963140150027,
      longitude: 15.50744679956206,
      website: "https://www.facebook.com/sportovni.a.detska.moda.jilemnice",
      detailHref: "/branches/detail/?id=7565",
      openingHours: `Po - Pá: 9:00 - 12:00 - 12:30 - 17:00 <br>

Sobota: 9:00 - 11:00 <br>
Neděle: ZAVŘENO <br>`,
      region: "Liberec",
    },
    {
      title: "SRDCOFKA",
      address: "SRDCOFKA, Ruská 80, 43001 Chomutov",
      phone: "<a href='tel:+420 737819540'>+420 737 819 540</a>",
      email: "<a href='mailto:srdcofka@seznam.cz'>srdcofka@seznam.cz</a>",
      latitude: 50.45985577924463,
      longitude: 13.420105555672846,
      website: "https://www.facebook.com/Srdcofka-1855877981394081/",
      detailHref: "/branches/detail/?id=7500",
      openingHours: `
Út - Pá: 10:00 - 17:00 <br>

Sobota: 10:00 - 12:00 <br>
Neděle: ZAVŘENO <br>`,
      region: "Chomutov",
    },
    {
      title: "Zlatá Žirafa Párty shop - obchod pro děti",
      address:
        "Zlatá Žirafa Párty shop - obchod pro děti, Ulice 5.Května 137, 33901 Klatovy",
      phone: "<a href='tel:+420 601 323 550'>+420 601 323 550</a>",
      email: "<a href='mailto:obchod@zlatazirafa.cz'>obchod@zlatazirafa.cz</a>",
      latitude: 49.38309999095824,
      longitude: 13.29636452742687,
      website: "https://www.zlatazirafa.cz/",
      detailHref: "/branches/detail/?id=7503",
      openingHours: `Po - Pá: 9:00 - 18:00 <br>

Sobota: 9:00 - 13:00 <br>
Neděle: ZAVŘENO <br>`,
      region: "Klatovy",
    },
    {
      title: "Tady u nás",
      address: "Tady u nás, Kostelní 21, 74101 Nový Jičín",
      phone: "<a href='tel:+420 604527557'>+420 604 527 557</a>",
      email:
        "<a href='mailto:tadyunas.obchod@gmail.com'>tadyunas.obchod@gmail.com</a>",
      latitude: 49.59561629994871,
      longitude: 18.01167024969899,
      website: "https://www.tadyunas.cz",
      detailHref: "/branches/detail/?id=9251",
      openingHours: `Po - Pá: 9:00 - 12:30 - 13:00 - 17:00 <br>

Sobota: 9:00 - 12:00 <br>
Neděle: ZAVŘENO <br>`,
      region: "Moravskoslezský",
    },
    {
      title: "Tady u nás v Olomouci",
      address: "Tady u nás v Olomouci, Ostružnická 336/28, 77900 Olomouc",
      phone: "<a href='tel:+420 737772190'>+420 737 772 190</a>",
      email:
        "<a href='mailto:tadyunas.olomouc@gmail.com'>tadyunas.olomouc@gmail.com</a>",
      latitude: 49.59500928001589,
      longitude: 17.253364096074545,
      website: "https://www.tadyunas.cz/",
      detailHref: "/branches/detail/?id=15467",
      openingHours: `Po - Pá: 9:30 - 12:30 - 13:00 - 18:00 <br>

Sobota: 10:00 - 14:00 <br>
Neděle: ZAVŘENO <br>`,
      region: "Olomouc",
    },
    {
      title: "BeHappy",
      address: "BeHappy, Smetanovo náměstí 28, 57001 Litomyšl",
      phone: "<a href='tel:+420 605 465 074'>+420 605 465 074</a>",
      email:
        "<a href='mailto:behappylitomysl@gmail.com'>behappylitomysl@gmail.com</a>",
      latitude: 49.8724920283544,
      longitude: 16.30971085442421,
      website: "https://www.facebook.com/BeHappyLitomysl/",
      detailHref: "/branches/detail/?id=7506",
      openingHours: `Po - Pá: 9:00 - 17:00<br>
Sobota: 9:00 – 12:00<br>
Neděle:	ZAVŘENO <br>`,
      region: "Pardubice",
    },
    {
      title: "Butik Brusinky",
      address: "Butik Brusinky, Kollárova 336, 66902 Znojmo",
      phone: "<a href='tel:+420 776795900'>+420 776 795 900</a>",
      email:
        "<a href='mailto:adelabrusinky@gmail.com'>adelabrusinky@gmail.com</a>",
      latitude: 48.85395361676398,
      longitude: 16.05096922646722,
      website: "https://www.facebook.com/ButikBrusinky",
      openingHours: `Po - Pá: 9:00 - 17:00 <br>
Sobota: 9:00 - 12:00 <br>
Neděle: ZAVŘENO <br>`,
      detailHref: "/branches/detail/?id=7507",
    },
    {
      title: "KKboty.cz",
      address: "KKboty, Rapotín 824, 78814 Rapotín",
      phone: "<a href='tel:+420 588 288 785'>+420 588 288 785</a>",
      email: "<a href='mailto:info@kkboty.cz'>info@kkboty.cz</a>",
      latitude: 49.99593310305439,
      longitude: 17.010844177243023,
      website: "https://www.kkboty.cz/",
      detailHref: "/branches/detail/?id=7509",
      openingHours: `Po, Út, Čt, Pá: 9:00 - 12:00 - 13:00 - 17:00 <br>

Středa: 9:00 - 12:00 - 13:00 - 18:00 <br>

Sobota: 9:00 - 13:00 <br>
Neděle: ZAVŘENO <br>`,
      region: "Olomouc",
    },
    {
      title: "Obuv Bojkovice",
      address: "Obuv Bojkovice, Komenského 237, 68771 Bojkovice",
      phone: "<a href='tel:+420 778 589 807'>+420 778 589 807</a>",
      email:
        "<a href='mailto:obuvbojkovice@gmail.com'>obuvbojkovice@gmail.com</a>",
      latitude: 49.03702208275682,
      longitude: 17.811920658354744,
      website: "https://www.facebook.com/Obuv-Bojkovice-101118928411654/",
      detailHref: "/branches/detail/?id=7511",
      openingHours: `Po - Pá: 8:00 - 12:00 - 13:00 - 16:00 <br>

Sobota: 8:00 - 10:30 <br>
Neděle: ZAVŘENO <br>`,
      region: "Zlín",
    },
    {
      title: "Pohodlné botky - OC SEVER",
      address:
        "Pohodlné botky - OC SEVER, Mírové náměstí 103, 400 01 Ústí nad Labem",
      phone: "<a href='tel:+420 724 030 507'>+420 724 030 507</a> ",
      email: "<a href='mailto:info@pohodlnebotky.cz'>info@pohodlnebotky.cz</a>",
      latitude: 50.660042118040835,
      longitude: 14.04083826793902,
      website: "https://www.pohodlnebotky.cz/",
      detailHref: "/branches/detail/?id=7513",
      openingHours: `Po, St, Pá: 9:30 - 17:00 <br>
  Út, Čt: 9:30 - 15:00 <br>
Sobota: 9:30 - 12:00 <br>
Neděle: ZAVŘENO <br>`,
      region: "Ústí nad Labem",
    },
    {
      title: "Bobu.cz",
      address: "Bobu.cz, Třída T.G.Masaryka 1118, 73801 Frýdek-Místek",
      phone: "<a href='tel:+420 606 073 245'>+420 606 073 245</a>",
      email: "<a href='mailto:info@bobu.cz'>info@bobu.cz</a>",
      latitude: 49.682239671460806,
      longitude: 18.3550619960809,
      website: "https://bobu.cz/",
      detailHref: "/branches/detail/?id=7514",
      openingHours: `Po - Čt: 8:30 - 17:00 <br>

Pátek: 8:30 - 15:00 <br>
Sobota: ZAVŘENO <br>
Neděle: ZAVŘENO <br>`,
      region: "Moravskoslezský",
    },
    {
      title: "Autoria",
      address: "Autoria, Karlovo náměstí 61, 67401 Třebíč",
      phone: "<a href='tel:+420 776700546'>+420 776 700 546</a>",
      email: "<a href='mailto:autoria.cz@gmail.com'>autoria.cz@gmail.com/a>",
      latitude: 49.21567524392642,
      longitude: 15.879408956258228,
      website:
        "https://www.google.cz/maps/place/Karlovo náměstí 61,67401 Třebíč",
      detailHref: "/branches/detail/?id=7515",
      openingHours: `Po - Pá: 9:00 - 17:00 <br>
Sobota: ZAVŘENO <br>
Neděle: ZAVŘENO <br>`,
      region: "Vysočina",
    },
    {
      title: "Dětská móda a sport - IT Centrum",
      address:
        "Dětská móda a sport - IT Centrum, Krkonošská 16, 54301 Vrchlabí",
      phone: "<a href='tel:+420 721242679'>+420 721 242 679</a>",
      email: "<a href='mailto:schemon@seznam.cz'>schemon@seznam.cz</a>",
      latitude: 50.62740228085506,
      longitude: 15.610443885135792,
      website: "https://www.google.cz/maps/place/Krkonošská 16,54301 Vrchlabí",
      detailHref: "/branches/detail/?id=7542",
      openingHours: `Po - Pá: 9:00 - 12:00 - 13:00 - 17:00 <br>
Sobota: 9:00 - 12:00 <br>
Neděle: ZAVŘENO <br>`,
      region: "Královéhradecký",
    },
    {
      title: "Minilidi",
      address: "OC KASKÁDY TACHOV, Zámecká 2111, 34701 Tachov",
      phone: "<a href='tel:+420 731581344'>+420 731581344</a>",
      email:
        "<a href='mailto:obchodminilidi@seznam.cz'>obchodminilidi@seznam.cz/a>",
      latitude: 49.79802013607071,
      longitude: 12.632049083258199,
      website:
        "https://www.facebook.com/MiniLidi-d%C4%9Btsk%C3%A9-a-kojeneck%C3%A9-zbo%C5%BE%C3%AD-1137639559702713/",
      detailHref: "/branches/detail/?id=7544",
      openingHours: `Po - Pá: 9:00 - 17:00 <br>

Sobota: ZAVŘENO <br>
Neděle: ZAVŘENO <br>`,
      region: "Plzeňský",
    },
    {
      title: "FREESTYLE DANCE SHOP",
      address: "FREESTYLE DANCE SHOP, Školní 1000, 41501 Teplice",
      phone: "<a href='tel:+420725649007'>+420 725 649 007</a>",
      email:
        "<a href='mailto:freestyledance.cz@gmail.com'>freestyledance.cz@gmail.com</a>",
      latitude: 50.64273417203958,
      longitude: 13.823809097706873,
      website: "https://www.freestyle-dance.cz/",
      detailHref: "/branches/detail/?id=7549",
      openingHours: `Po - Pá: 9:00 - 15:00 <br>

Sobota: ZAVŘENO <br>
Neděle: ZAVŘENO <br>`,
      region: "Ústí nad Labem",
    },
    {
      title: "MOYO MÍSTO",
      address: "MOYO MÍSTO, Pražská 614, 294 71 Benátky nad Jizerou",
      phone: "<a href='tel:+420 776 777 503'>+420 776 777 503</a>",
      email:
        "<a href='mailto:monika.marosi@icloud.com'>monika.marosi@icloud.com</a>",
      latitude: 50.28498220397457,
      longitude: 14.827693367288896,
      website: "https://www.moyomisto.cz/",
      detailHref: "/branches/detail/?id=10295",
      openingHours: `Po - Ne: viz. <a href="https://moyo.isportsystem.cz">rezervační systém </a> <br>
      `,
      region: "Středočeský",
    },
    {
      title: "Pink butik",
      address: "Pink butik, Růžová 297, 46001 Liberec",
      phone: "<a href='tel:+420775203423'>+420 775 203 423</a>",
      email: "<a href='mailto:pinkbutik@email.cz'>pinkbutik@email.cz</a>",
      latitude: 50.77039976475788,
      longitude: 15.053780368876371,
      website: "https://www.pinkbutik.cz",
      detailHref: "/branches/detail/?id=7553",
      openingHours: `Po - St, Pá: 10:00 - 17:00 <br>

Čtvrtek: 10:00 - 18:00 <br>

Sobota: ZAVŘENO <br>
Neděle: ZAVŘENO <br>`,
      region: "Liberec",
    },
    {
      title: "DaMa textil a spodní prádlo",
      address: "DaMa textil a spodní prádlo, Kavánova 175, 51401 Jilemnice",
      phone: "<a href='tel:+420 603257275'>+420 603 257 275</a>",
      email:
        "<a href='mailto:danamala1111@seznam.cz'>danamala1111@seznam.cz</a>",
      latitude: 50.60887257837621,
      longitude: 15.507590820455029,
      website: "https://www.facebook.com/DaMaTextilaspodnipradlo",
      detailHref: "/branches/detail/?id=7566",
      openingHours: `Po - Pá: 8:00 - 17:00 <br>
Sobota: 9:00 - 11:00 <br>
Neděle: ZAVŘENO <br>`,
      region: "Liberec",
    },
  ];

  function initRegions() {
    const select = document.getElementById("regionFilter");
    const regions = [
      ...new Set(stores.map((store) => store.region).filter(Boolean)),
    ].sort();
    regions.forEach((region) => {
      const opt = document.createElement("option");
      opt.value = region;
      opt.textContent = region;
      select.appendChild(opt);
    });
  }

  // Nová proměnná pro stránkování
  let currentIndex = 0;
  const PAGE_SIZE = 8;
  let currentList = stores;

  // Vykreslit seznam prodejen s možností načíst další
  function renderStores(list, reset = false) {
    const container = document.getElementById("storesList");
    if (reset) {
      container.innerHTML = "";
      currentIndex = 0;
    }
    // Odstraň předchozí tlačítko
    const oldBtn = document.getElementById("loadMoreStores");
    if (oldBtn) oldBtn.remove();

    // Vykresli další stránku
    const slice = list.slice(currentIndex, currentIndex + PAGE_SIZE);
    slice.forEach((store) => {
      const card = document.createElement("div");
      card.className = "store-card";
      if (store.openingHours) {
        store.openingHours = store.openingHours.replace(
          /([A-Za-zÁÉÍÓÚÝČĎĚŇŘŠŤŮŽáéíóúýčďěňřšťůž]+):/g,
          "<strong>$1: </strong>"
        );
      }
      card.innerHTML = `
        <div class="top">
            <h3>${store.title}</h3>
         
            ${
              store.openingHours
                ? `<div class="opening-hours">${store.openingHours}</div>`
                : ""
            }
            <p class="address"><span class="icon"></span>${store.address}</p>
            <p class="phone"><span class="icon"></span>${store.phone}</p>
            <p class="email"><span class="icon"></span>${store.email}</p>
            <p class="website"><span class="icon"></span>${
              store.website
                ? `<a href="${store.website}" target="_blank">${store.website}</a>`
                : ""
            }</p>
        </div>
        <div class="bottom">
          <button class="btn btn-primary" onclick="window.open('https://www.google.com/maps?q=${encodeURIComponent(
            store.address
          )}', '_blank')">Zobrazit na mapě</button>
        </div>
      `;
      container.appendChild(card);
    });

    currentIndex += PAGE_SIZE;

    // Pokud zbývají další položky, zobraz tlačítko
    if (currentIndex < list.length) {
      // Odstraň předchozí wrapper s tlačítky, pokud existuje
      const oldWrapper = document.querySelector(".storelist-btns");
      if (oldWrapper) oldWrapper.remove();

      // Vytvoření wrapperu pro tlačítka
      const btnWrapper = document.createElement("div");
      btnWrapper.className = "storelist-btns";

      // Tlačítko "Zpět nahoru"
      const backToTop = document.createElement("button");
      backToTop.className = "btn btn-primary back-to-top";
      backToTop.innerHTML = "Zpět nahoru";
      backToTop.addEventListener("click", () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
      });

      // Tlačítko "Načíst další"
      const btn = document.createElement("button");
      btn.id = "loadMoreStores";
      btn.className = "btn btn-primary load-more";
      btn.innerHTML = "Načíst další";
      btn.addEventListener("click", () => renderStores(list));

      // Přidej tlačítka do wrapperu
      btnWrapper.appendChild(backToTop);
      btnWrapper.appendChild(btn);

      // Přidej wrapper za seznam poboček
      container.insertAdjacentElement("afterend", btnWrapper);
    }
  }

  // Filtr podle regionu
  document
    .getElementById("regionFilter")
    .addEventListener("change", function () {
      const value = this.value;
      currentList = value ? stores.filter((s) => s.region === value) : stores;
      renderStores(currentList, true);
    });

  // Inicializace
  initRegions();
  renderStores(stores, true);
};

export { storeList };
